'use strict';

var AlgoliaUtils = {
  initialize: function initialize(algoliasearch, config) {
    //return client
    return algoliasearch(config['appId'], config['apiAdminKey']);
  },

  indexDocuments: function indexDocuments(client, teamsWithEvents, indexableDocs) {
    var indexes = AlgoliaUtils.createIndicesForEachTeam(client, teamsWithEvents);
    AlgoliaUtils.addObjectsToIndices(indexes, indexableDocs).then(function (result) {
      console.log('result- ', result);
      return;
    });
  },

  createIndicesForEachTeam: function createIndicesForEachTeam(client, teamsWithEvents) {
    var allIndexes = {};
    Object.keys(teamsWithEvents).forEach(function (teamId) {
      console.log('Creating index ' + teamId + '-events');
      allIndexes[teamId] = client.initIndex(teamId + '-events');
      allIndexes[teamId].setSettings({
        //TODO set searchable setting
      });
    });
    return allIndexes;
  },

  cleanUpDocs: function cleanUpDocs(indexableDocs) {
    return indexableDocs.filter(function (doc) {
      return doc !== null;
    });
  },

  getEventIndexForTeam: function getEventIndexForTeam(client, teamId) {
    return client.initIndex(teamId + '-events');
  },

  addObjectsToIndices: function addObjectsToIndices(indexes, indexableDocs) {
    return new Promise(function (resolve, reject) {
      var allIndexes = {};
      var added = 0;

      var _loop = function _loop(teamId) {
        if (indexes[teamId]) {
          var cleanIndexableDocs = AlgoliaUtils.cleanUpDocs(indexableDocs[teamId]);
          indexes[teamId].addObjects(cleanIndexableDocs, function (err, content) {
            if (err) {
              console.error('Error adding objects to indice with team id ' + teamId + '- ' + err);
            } else {
              added++;
              if (added === Object.keys(indexableDocs).length) {
                resolve('success');
              }
            }
          });
        }
      };

      for (var teamId in indexableDocs) {
        _loop(teamId);
      }
    });
  },

  updateIndices: function updateIndices(index, indexableDocs) {
    return new Promise(function (resolve, reject) {
      index.saveObjects(indexableDocs, function (err, content) {
        if (err) {
          console.log('Error updating indices', err);
          reject(err);
        } else {
          resolve(content);
        }
      });
    });
  }

};

module.exports = AlgoliaUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/AlgoliaUtils.js
// module id = 1040
// module chunks = 0